"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNotificationWrapper = exports.StyledNotificationContent = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../../general");
exports.StyledNotificationContent = (0, styled_components_1.default)(general_1.Flexbox) `
  position: absolute;
  width: 21.75rem;
  top: 2.3rem;
  right: 0;
  max-height: 0;
  z-index: 999;
  overflow: hidden;
  transition: all 0.2s linear;
  box-shadow: ${theme_1.shadows.default(theme_1.grayScale[900])};
  background-color: ${theme_1.grayScale[50]};
  border-radius: 8px;

  * {
    opacity: 0;
    transition: all 0.2s linear;
  }
`;
exports.StyledNotificationWrapper = (0, styled_components_1.default)(general_1.Flexbox) `
  ${({ isOpen }) => {
    return (0, styled_components_1.css) `
      position: relative;
      cursor: pointer;

      ${isOpen &&
        (0, styled_components_1.css) `
        ${exports.StyledNotificationContent} {
          max-height: 400px;
          * {
            opacity: 1;
          }
        `}
      }
    `;
}}
`;
//# sourceMappingURL=styles.js.map